import controller from './things-toolbox.controller';

const template = require('./things-toolbox.html');

export default {
    bindings: {
        predefinedQuery: '<',
        onShowAdvancedSearch: '&',
        onSearchResult: '&',
        onEmptySearch: '&',
        selectedThings: '<'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/things-toolbox/things-toolbox.component.js